import { NextPageContext } from "next";
import { SuperJSONResult } from "superjson/dist/types";

import { serializeProps } from "src/utilities/ssr/superjson";

type EdoServerSideProps = {
  notFound?: boolean;
  [key: string]: any;
  props?: { [key: string]: any };
};

type EdoServerSidePropsHandler = (
  ctx: NextPageContext
) => Promise<EdoServerSideProps>;

type EdoServerSideSerializationResult =
  | { props: SuperJSONResult }
  | { notFound: boolean }
  | { redirect: { destination: string; permanent?: boolean } };

export function withPropsSerialization(handler?: EdoServerSidePropsHandler) {
  return async (
    ctx: NextPageContext
  ): Promise<EdoServerSideSerializationResult> => {
    const result = handler ? await handler(ctx) : { props: {} };

    // Do not serialize if the result contains a notFound property
    if ("notFound" in result && result.notFound) {
      return { notFound: true };
    }

    // Do not serialize if result contains a redirect property
    if ("redirect" in result) {
      return {
        redirect: {
          destination: result.redirect.destination,
          permanent: false,
        },
      };
    }

    return serializeProps(result.props);
  };
}
